import { render, staticRenderFns } from "./invoice-print-journal.vue?vue&type=template&id=a8359812&"
import script from "./invoice-print-journal.vue?vue&type=script&lang=js&"
export * from "./invoice-print-journal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports